
































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {IRole} from '@/store/modules/views/role/states'

@Component({
  components: { CustomMap },
})
export default class CreateStaffDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private useritems = ''
  private menu = false
  private userId = ''
  private centeritems = ''
  private loading = false
  private role: Partial<IRole> = {}

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get isDisabledCenter() {
    return !(this.role && this.role.requireCenter)
  }

  get openDialog() {
    return this.open
  }

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  @Getter('role/roleLists')
  private roleItemLists!: () => void

  @Getter('user/userLists')
  private userItemLists!: () => void

  @Action('user/getUserListByRoleId')
  private getUserList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
    id: string,
  }) => void

  // tslint:disable-next-line:adjacent-overload-signatures
  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  public async created() {
    await Promise.all([
      this.getuserFunc(),
    ])
  }

  get userLists() {
    return this.userItemLists
  }

  private async getuserFunc() {
    await this.getUserList({
      headers: {
        page: 1,
        limit: 99999,
        sortBy: 'name',
        sortDesc: false,
        search: Buffer.from(this.optionUser.search).toString('base64'),
        filter: Buffer.from('{}').toString('base64'),
      },
      id: '11175c71fbe64ad49759e94b7f5b3a07',
    })
  }

  get createLeaderDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createStaffAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }

  private async changeUser() {
    if (this.useritems != null ) {
      this.userId = this.useritems[`_id`]
    }
    this.menu = false
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private async createStaffAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      try {
        await HttpRequestServiceWithToken.putByLevel(`${process.env.VUE_APP_API_URL}/v1`,
            `user/${this.userId}/role/${this.role._id}`,
            { centerId: this.centeritems },
        ),
            this.updateSnackbar({txt: 'บันทึกเจ้าหน้าที่สำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
